import { Component } from '@angular/core';

@Component({
    selector: 'app-task-execution-report',
    templateUrl: './task-execution-report.component.html',
    styleUrl: './task-execution-report.component.css',
    standalone: false
})
export class TaskExecutionReportComponent {

}
